export enum ReportTypes {
  ANALYTIC = "analytic",
  SYNTHETIC = "synthetic"
}
